export default __webpack_public_path__ + "static/media/Vambraces of the Bloodhunter (nm).c018dc96.jpg";